import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Numer telefonu',
      placeholder: 'Wpisz numer telefonu',
    },
    email: {
      label: 'Adres e-mail',
      placeholder: 'Wpisz adres e-mail',
    },
  },
  channel_chooser: {
    title: 'Wyślij kod przez',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Bezpłatny, najszybszy',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Standardowa wiadomość SMS',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'E-mail',
      subtitle: 'Kod prosto na Twoją skrzynkę',
    },
  },
  otp: {
    title: 'Wpisz kod weryfikacyjny',
    send_code: 'Wyślij kod',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Wysłano przez <strong>WhatsApp</strong> na <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Wysłano przez <strong>SMS</strong> na <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Wysłano przez <strong>e-mail</strong> na <strong>{{phone}}</strong>',
    },
    sent_to: 'Wysłano na',
    resend: {
      title: 'Nie dotarł do Ciebie kod?',
      countdown: 'Wyślij ponownie za',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Nie dotarł do Ciebie kod przez e-mail?',
          button: 'Wyślij ponownie e-mailem',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Nie dotarł do Ciebie kod?',
          button: 'Wyślij ponownie przez SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Nie dotarł do Ciebie kod?',
          button: 'Wyślij ponownie przez WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Wyślij przez SMS',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Wyślij przez WhatsApp',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Wiadomość z kodem weryfikacyjnym została wysłana na Twój telefon. Wpisz kod, aby kontynuować.',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Wpisz kod wysłany na ten adres: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Wiadomość WhatsApp z kodem weryfikacyjnym została wysłana na Twój telefon. Wpisz kod, aby kontynuować.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Wskazówka: Sprawdź skrzynkę odbiorczą i folder spam.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Uwaga — kod jest wysyłany od <strong>{{sender}}</strong>, naszego partnera technologicznego.',
    business_account: 'Konto firmowe',
    message: '<strong>123456</strong> to Twój kod weryfikacyjny. Dla bezpieczeństwa nie udostępniaj tego kodu.',
  },
  error_messages: {
    frequent_requests:
      'Sprawdź swoje wiadomości. Kod został już wysłany na podany numer. Jeśli nie dotarł, sprawdź numer telefonu lub spróbuj ponownie za 10 minut.',
    frequent_requests_email:
      'Sprawdź skrzynkę odbiorczą i folder spam. Kod został już wysłany na ten adres. Jeśli nie dotarł, spróbuj ponownie za 10 minut.',
    invalid_number: 'Nieprawidłowy numer. Spróbuj ponownie.',
    invalid_email: 'Nie udało się wysłać kodu na ten adres e-mail. Sprawdź go i spróbuj ponownie.',
    email_not_on_file:
      'Ten numer telefonu ma już konto bez adresu e-mail. Skontaktuj się z {{support_email}}, aby go dodać — do tego czasu nie możemy wysyłać kodów dla tego numeru e-mailem.',
    turnstile_required: 'Przed żądaniem nowego kodu ukończ weryfikację.',
    generic_error: 'Ups, coś poszło nie tak. Odśwież stronę i spróbuj ponownie.',
    change_phone_number_unsuccessful: 'Nie udało się zmienić numeru telefonu. Spróbuj ponownie.',
  },
  toasts: {
    code_sent: 'Kod wysłany',
  },
};
